<script>
export default {
  page: {
    title: 'Loading',
    meta: [{ name: 'description', content: 'The Loading page.' }],
  },
}
</script>

<template>
  <CWrapper>
    <div class="c-app justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </CWrapper>
</template>
